import { render, staticRenderFns } from "./mobile-address.vue?vue&type=template&id=31a0723c&scoped=true"
import script from "./mobile-address.vue?vue&type=script&lang=ts"
export * from "./mobile-address.vue?vue&type=script&lang=ts"
import style0 from "./mobile-address.vue?vue&type=style&index=0&id=31a0723c&prod&lang=less&scoped=true"
import style1 from "./mobile-address.vue?vue&type=style&index=1&id=31a0723c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0723c",
  null
  
)

export default component.exports